import { getGridStyles } from '@bingads-webui-campaign-react/accounts-grid-factory';
import { legacyUIBlockerStyle, labelColumnHeaderStyle } from '@bingads-webui-campaign-react/common-styles';
import { getLinkAccountButtonStyle } from '@bingads-webui-campaign-react/accounts-summary-common';
import { inlineChartContainerStyle } from '@bingads-webui-campaign-react/inline-chart-style';

export const getPerformanceStyles = (components, { palette = {} }) => ({
  inlineChartContainer: inlineChartContainerStyle(palette),
  IONotificationsContainer: {
    boxShadow: 'inset 0px 4.6px 1.8px -4px rgba(0, 0, 0, 0.108), inset 0px 7.2px 7.2px -4px rgba(0, 0, 0, 0.132)',
    padding: [8, 24],
    '&:empty': {
      padding: 0,
    },
  },
  gridContainer: {
    ...getLinkAccountButtonStyle(components, { palette }),
  },
  grid: {
    ...getGridStyles(components, { palette }),
    ...legacyUIBlockerStyle({ palette }),

    // column width override
    '&& .table-container colgroup.column-group .col-AccountName': {
      width: 300,
      minWidth: 300,
    },
  },
  dsaSuspensionWarning: {
    padding: '0 15px 8px 32px',
  },
  '@global': {
    ...labelColumnHeaderStyle(),
  },
});
